import { render, staticRenderFns } from "./InicioPantalla.vue?vue&type=template&id=79891cac&scoped=true&"
import script from "./InicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./InicioPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./InicioPantalla.vue?vue&type=style&index=0&id=79891cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79891cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79891cac', component.options)
    } else {
      api.reload('79891cac', component.options)
    }
    module.hot.accept("./InicioPantalla.vue?vue&type=template&id=79891cac&scoped=true&", function () {
      api.rerender('79891cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/InicioPantalla.vue"
export default component.exports